import React from 'react';

import { PDFPreview } from '../../../components/Widgets/PDFWidget/PDFPreview';
import { PDFThumbnail } from '../../../components/Widgets/PDFWidget/PDFThumbnail';
import { PdfWidgetDataProvider } from '../../../components/Widgets/PDFWidget/PdfWidgetDataProvider';
import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { useContentBlocksContext } from '../../ContentBlocksContext';
import { ExistingStudentWidgetProps } from '../Widget';
import { Alignment, PdfViewMode, PDFWidget as PDFWidgetModel } from '@ael/core-api';
import classNames from 'classnames';

import './pdf-widget.scss';

export const PDFWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const { value: pdfWidget } = widget as PDFWidgetModel;
  const { inSmallWindow } = useContentBlocksContext();
  return (
    <StudentWidgetWrapper>
      <div
        className={classNames('student-pdf-widget', {
          'student-pdf-widget--align-left': pdfWidget.properties.alignment === Alignment.left,
          'student-pdf-widget--align-right': pdfWidget.properties.alignment === Alignment.right,
          'uno-min-h-150px': pdfWidget.properties.mode === PdfViewMode.Preview,
        })}
      >
        <PdfWidgetDataProvider assetId={pdfWidget.data.assetId} key={pdfWidget.data.assetId} widgetId={widget._id}>
          {(data) =>
            pdfWidget.properties.mode === PdfViewMode.Preview ? (
              <PDFPreview
                src={data && data.assetUrl}
                showToolbar
                inSmallWindow={inSmallWindow}
                allowDownload={pdfWidget.properties.allowDownload}
              />
            ) : (
              <PDFThumbnail src={data?.assetUrl} fileName={data?.assetName} />
            )
          }
        </PdfWidgetDataProvider>
      </div>
    </StudentWidgetWrapper>
  );
};
